<template>
  <div class="container" v-if="showPage">
    <Menu />
    <div class="content">
      <Header />
      <div class="pageContainer">
        <div class="page">
          <router-view :key="$route.fullPath" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "cpnts/web/Menu.vue";
import Header from "cpnts/web/Header.vue";
import { checkLoginTypeMixin } from "../../../mixins/checkLoginTypeMixin";

export default {
  data() {
    return {
      showPage: false
    };
  },
  components: {
    Menu,
    Header
  },
  mixins: [checkLoginTypeMixin],
  mounted() {
    this.loginTypeCheck();
    this.triggerTabs();
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;
  display: flex;
}

.menu {
  width: 200px;
  height: 100%;
  background-color: #f6f7fc;
  flex-shrink: 0;
  transition: all 0.3s;
}

.content {
  flex: auto;
  overflow: auto;
  height: 100%;
  width: calc(100% - 200px);
}

.header {
  height: 60px;
  width: 100%;
  border-bottom: solid 1px #eeeeee;
  padding-right: 40px;
}

.pageContainer {
  height: calc(100% - 60px);
  width: 100%;
  overflow: auto;

  /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
    background-color: transparent;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }

  /*定义滑块 内阴影+圆角*/
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(144, 147, 153, 0.5);

    &:hover {
      cursor: pointer;
      background-color: rgba(144, 147, 153, 0.7);
    }
  }
}

.page {
  min-width: 1200px;
}
.page {
  min-width: 1200px;
}
</style>
